// extracted by mini-css-extract-plugin
export default {"container":"MileageAndGenerator_container__EOk7j","title":"MileageAndGenerator_title__BZpO3","value":"MileageAndGenerator_value__jMHn0"};